<template lang="html">
  <button v-bind="$attrs" v-on="$listeners" :disabled="loading || $attrs.disabled">
    <i class="fa fa-spin" :class="{ 'fa-circle-notch': loading }"></i>
    <slot/>
  </button>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: {
      icon: {
        default: 'fa-circle-notch'
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="css">
</style>
